import { Spacer as Spacer$1 } from '@zillow/constellation';
import { CustomPropTypes } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';

var BlockSpacer = function BlockSpacer(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var _attrs$paddingTop = attrs.paddingTop,
    paddingTop = _attrs$paddingTop === void 0 ? {
      default: 'lg',
      lg_lte: 'md',
      sm_lte: 'sm'
    } : _attrs$paddingTop;
  return /*#__PURE__*/React.createElement(Spacer$1, {
    key: index,
    paddingTop: paddingTop
  });
};
BlockSpacer.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    paddingTop: CustomPropTypes.inlineMediaQuery(PropTypes.string)
  }),
  index: PropTypes.number
} : {};
var Spacer = BlockSpacer;

export { Spacer as default };
